module.exports = __webpack_public_path__ + "static/media/konkurs.b927f0b3.png";